export default "__VITE_ASSET__4uGZEVV0__"